import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const getTreatmentState = (state: RootState) => state.treatment;

export const selectTreatments = createSelector(
  [getTreatmentState],
  (treatmentState) => treatmentState.treatments
);

export const selectLoadingTreatments = createSelector(
  [getTreatmentState],
  (treatmentState) => treatmentState.loadingTreatments
);

export const selectTreatmentsSearchResults = createSelector(
  [getTreatmentState],
  (treatmentState) => treatmentState.treatmentSearchResults
);

export const selectLoadingTreatmentsSearchResults = createSelector(
  [getTreatmentState],
  (treatmentState) => treatmentState.loadingSearchTreatments
);

export const selectLoadingInsertTreatments = createSelector(
  [getTreatmentState],
  (treatmentState) => treatmentState.loadingInsertTreatments
);
